













import {Component, Mixins} from 'vue-property-decorator';
import InputMixin from '@/components/input/InputMixin';
import {Editor, EditorContent} from '@tiptap/vue-2';
import StarterKit from '@tiptap/starter-kit';
import Table from '@tiptap/extension-table';
import TableRow from '@tiptap/extension-table-row';
import TableCell from '@tiptap/extension-table-cell';
import TableHeader from '@tiptap/extension-table-header';
import Highlight from '@tiptap/extension-highlight';
import TextStyle from '@tiptap/extension-text-style';
import { Color } from '@tiptap/extension-color';
import TaskList from '@tiptap/extension-task-list';
import TaskItem from '@tiptap/extension-task-item';
import Link from '@tiptap/extension-link';
import TextAlign from '@tiptap/extension-text-align';
import BasicToolbar from '@/components/editor/toolbar/BasicToolbar.vue';
import TableToolbar from '@/components/editor/toolbar/TableToolbar.vue';

@Component({
  components: {TableToolbar, BasicToolbar, EditorContent},
  mixins: [InputMixin]
})
export default class TiptapEditor extends Mixins<InputMixin>(InputMixin) {
  private editor: Editor | null = null;

  public mounted() {
    this.editor = new Editor({
      content: this.value,
      extensions: [
        StarterKit.configure({
          heading: {
            HTMLAttributes: {
              class: 'tiptap__cube_heading'
            }
          },
          paragraph: {
            HTMLAttributes: {
              class: 'tiptap__cube_paragraph'
            }
          },
          bold: {
            HTMLAttributes: {
              class: 'tiptap__cube_bold'
            }
          },
          italic: {
            HTMLAttributes: {
              class: 'tiptap__cube_italic'
            }
          },
          strike: {
            HTMLAttributes: {
              class: 'tiptap__cube_strike'
            }
          },
          code: {
            HTMLAttributes: {
              class: 'tiptap__cube_code'
            }
          },
          codeBlock: {
            HTMLAttributes: {
              class: 'tiptap__cube_codeBlock'
            }
          },
          horizontalRule: {
            HTMLAttributes: {
              class: 'tiptap__cube_hr'
            }
          },
          bulletList: {
            HTMLAttributes: {
              class: 'tiptap__cube_bulletList'
            }
          },
          orderedList: {
            HTMLAttributes: {
              class: 'tiptap__cube_orderedList'
            }
          },
          listItem: {
            HTMLAttributes: {
              class: 'tiptap__cube_listItem'
            }
          }
        }),
        Table.configure({
          resizable: true,
          HTMLAttributes: {
            class: 'tiptap__cube_table',
          },
        }),
        TableRow.configure({
          HTMLAttributes: {
            class: 'tiptap__cube_table_tr',
          },
        }),
        TableCell.configure({
          HTMLAttributes: {
            class: 'tiptap__cube_table_td',
          },
        }),
        TableHeader,
        Highlight.configure({
          HTMLAttributes: {
            class: 'tiptap__cube_mark',
          },
        }),
        TextStyle,
        Color,
        TaskList.configure({
          HTMLAttributes: {
            class: 'tiptap__cube_taskList'
          }
        }),
        TaskItem.configure({
          nested: true,
          HTMLAttributes: {
            class: 'tiptap__cube_taskItem'
          }
        }),
        Link.configure({
          HTMLAttributes: {
            class: 'tiptap__cube_hyperLink'
          }
        }),
        TextAlign.configure({
          types: ['heading', 'paragraph'],
        })
      ],
      editorProps: {
        attributes: {
          class: ''
        }
      },
      onUpdate: () => {
        this.$emit('input', this.editor?.getHTML());

        this.$nextTick(() => {
          this.$store.commit('commitValue', {
            itemId: 'notice-editor',
            value: this.value,
            originValue: this.originValue
          });
        });
      },
    });
    this.editor.setEditable(!this.isReadOnly);
  }

  public beforeDestroy() {
    this.editor?.destroy();
  }
}
